export default function (uku) {
    this.loadSuccessHandler = function () {
        document.getElementById("mainView").classList.remove('blur');
        document.getElementById("loadingBar").style.display = "none";
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/js/rootCtrl.js
// module id = 19
// module chunks = 0